var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-widget-sequence-picker" }, [
    _c(
      "div",
      {
        staticClass: "chat-widget-sequence-picker__dropdown",
        class: { "is-open": _vm.dropdownOpen },
      },
      [
        _c(
          "button",
          {
            staticClass: "chat-widget-sequence-picker__trigger",
            attrs: { type: "button", disabled: _vm.disabled },
            on: { click: _vm.toggleDropdown },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "chat-widget-sequence-picker__trigger-text" },
              [
                _c(
                  "span",
                  { staticClass: "chat-widget-sequence-picker__trigger-label" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.activeSource
                          ? _vm.activeSource.label
                          : "Select a sequence"
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.activeSource
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "chat-widget-sequence-picker__trigger-count",
                      },
                      [_vm._v(_vm._s(_vm.activeSource.count) + " images")]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dropdownOpen,
                expression: "dropdownOpen",
              },
            ],
            staticClass: "chat-widget-sequence-picker__menu",
          },
          [
            _c(
              "div",
              { staticClass: "chat-widget-sequence-picker__menu-header" },
              [_vm._v("\n        IMAGE SEQUENCES LIBRARY\n      ")]
            ),
            _vm._v(" "),
            _vm._l(_vm.sources, function (src) {
              return _c(
                "button",
                {
                  key: src.id,
                  staticClass: "chat-widget-sequence-picker__menu-item",
                  class: { "is-active": src.id === _vm.activeSourceId },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.selectSource(src.id)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "chat-widget-sequence-picker__menu-label" },
                    [
                      _vm._v(
                        "\n          " + _vm._s(src.label) + "\n          "
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "chat-widget-sequence-picker__menu-count",
                        },
                        [_vm._v("· " + _vm._s(src.count))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  src.id === _vm.activeSourceId
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "chat-widget-sequence-picker__menu-check",
                        },
                        [_c("i", { staticClass: "bi bi-check-lg" })]
                      )
                    : _vm._e(),
                ]
              )
            }),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "chat-widget-sequence-picker__slots" },
      [
        _vm._l(_vm.activeSlots, function (slot) {
          return _c(
            "button",
            {
              key: slot.key,
              staticClass: "chat-widget-sequence-picker__slot",
              class: { "is-checked": _vm.isChecked(slot.key) },
              attrs: { type: "button", disabled: _vm.disabled },
              on: {
                click: function ($event) {
                  return _vm.toggle(slot.key)
                },
              },
            },
            [
              _c(
                "span",
                { staticClass: "chat-widget-sequence-picker__slot-check" },
                [
                  _vm.isChecked(slot.key)
                    ? _c("i", { staticClass: "bi bi-check-square-fill" })
                    : _c("i", { staticClass: "bi bi-square" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "chat-widget-sequence-picker__slot-label" },
                [_vm._v(_vm._s(slot.label))]
              ),
            ]
          )
        }),
        _vm._v(" "),
        !_vm.activeSlots.length
          ? _c("p", { staticClass: "chat-widget-sequence-picker__empty" }, [
              _vm._v("\n      No image types for this sequence.\n    "),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-sm chat-widget-sequence-picker__confirm",
        class: _vm.confirmStateClass,
        attrs: {
          type: "button",
          disabled:
            _vm.disabled || !_vm.selectedKeys.length || !_vm.hasPendingChanges,
        },
        on: { click: _vm.confirm },
      },
      [
        _vm._v(
          "\n    Confirm selection (" +
            _vm._s(_vm.selectedKeys.length) +
            ")\n  "
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "chat-widget-sequence-picker__trigger-icon" },
      [_c("i", { staticClass: "bi bi-soundwave" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "chat-widget-sequence-picker__trigger-chevron" },
      [_c("i", { staticClass: "bi bi-chevron-down" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }